import * as React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { getDisplayName } from 'gandi.react-helpers';
import { makeWrapHandler } from '../utils';
import { createAssetPath } from '../createAssetPath';
import { AssetPathContextProvider } from './AssetPathContextProvider';
/**
 * Decorate a component to provide requirements for @withAssetPath.
 * @example
 * ```js
 * const DecoratedComponent = provideAssetPath<typeof SomeComponent>(
    assetEndpoint,
    manifestContent,
    assetPrefix
  )(SomeComponent)
  ```
 */

var provideAssetPath = function provideAssetPath(assetEndpoint, manifestContent, assetPrefix) {
  return function (WrappedComponent) {
    function ProvideAssetPath(props) {
      return /*#__PURE__*/React.createElement(AssetPathContextProvider, {
        assetEndpoint: assetEndpoint,
        assetPrefix: assetPrefix,
        manifestContent: manifestContent
      }, /*#__PURE__*/React.createElement(WrappedComponent, props));
    }

    ProvideAssetPath.WrappedComponent = WrappedComponent;
    ProvideAssetPath.displayName = "ProvideAssetPath(".concat(getDisplayName(WrappedComponent), ")");
    var HoistedComponent = hoistNonReactStatic(ProvideAssetPath, WrappedComponent);
    var wrapHandler = makeWrapHandler(WrappedComponent, HoistedComponent, function (wrappedHandler) {
      return function (args) {
        var res = args.res;
        res.locals.assetPath = createAssetPath(assetEndpoint, manifestContent, assetPrefix);
        return wrappedHandler(args);
      };
    });
    wrapHandler('preFetch');
    wrapHandler('handleRedirect');
    wrapHandler('handleForm');
    wrapHandler('handlePageMeta');
    return HoistedComponent;
  };
};

export default provideAssetPath;